<div class="h-100">
  <div
    class="p-3 rounded bg-white shadow-sm h-100 d-flex flex-column align-items-start"
    [class.bg-light]="
      isRegisteredAndPending ||
      isRegisteredAndApproved ||
      isRegisteredAndRejected
    "
  >
    @if (coverImage) {
      <afra-image
        [fileId]="coverImage"
        imgClass="aspect-16/10 w-full! rounded object-cover mb-2"
        class="w-full"
        alt="workshop cover image"
      ></afra-image>
    } @else {
      <img
        class="aspect-16/10 w-full! rounded object-cover mb-2"
        src="/assets/images/video_cover.png"
        alt="workshop cover image"
      />
    }
    <div class="w-100">
      <h6 class="line-2">
        {{ title }}
      </h6>
    </div>
    @if (detailsLink) {
      <div>
        <a
          href="{{ detailsLink }}"
          target="_blank"
          pButton
          severity="primary"
          outlined
          class="mb-2 no-underline!"
          >جزئیات بیشتر
        </a>
      </div>
    }
    <div class="grow w-100">
      @for (row of rows; track $index) {
        <div class="mt-1 mb-auto flex">
          @if (row.icon) {
            <ng-icon
              [name]="row.icon"
              class="me-2 shrink-0 text-secondary"
            ></ng-icon>
          }
          <span class="align-self-center break-words min-w-0"
            >{{ row.title }}{{ row.title.length > 0 ? ":" : "" }}
            {{ row.value }}</span
          >
          &nbsp;
          @if (row.badge) {
            <span
              [class]="
                `badge bg-${row.badgeColor} rounded-pill  p-1 text-light ms-2 align-self-center`
              "
              style="text-wrap: nowrap"
              >{{ row.badge }}</span
            >
          }
        </div>
      }
      @if (description) {
        <div class="mt-2">
          <p>{{ description }}</p>
        </div>
      }
    </div>
    <div class="flex flex-wrap items-center gap-3! mt-2">
      @for (action of actions; track action.label) {
        @if (action.type === "button") {
          <p-button
            [icon]="action.icon"
            [label]="action.label"
            [severity]="action.severity"
            [outlined]="action.outlined"
            (click)="action.onClick && action.onClick($event)"
            [disabled]="action.disabled"
          >
          </p-button>
        } @else if (action.type === "link") {
          <a target="_blank" [href]="action.link">
            <p-button
              [icon]="action.icon"
              [label]="action.label"
              [severity]="action.severity"
              [outlined]="action.outlined"
              (click)="action.onClick && action.onClick($event)"
              [disabled]="action.disabled"
            >
            </p-button>
          </a>
        }
      }
    </div>
  </div>
</div>
